<ngx-loading-bar [fixed]="false" [includeBar]="false" diameter="24px" #apiLoader style="margin-left:-50%;">
</ngx-loading-bar>
<span [ngClass]="{'opacity-0': (loader.value$ | async)}">
  <ng-content></ng-content>
</span>